const state = {
  dialerData: {}
};

export default {
  state
};
